import styled from 'styled-components';

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.textNegative};
`;
